import { createBrowserClient } from '@supabase/ssr'
import type { Database } from '@/types/supabase'
import { getSharedCookieOptions } from './cookie-options'

export function createClient() {
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      // Host-aware: the domain only applies when this page's host belongs to
      // it (a mismatched Domain makes the browser reject the cookie entirely).
      // Guard `window`: models import this client and run server-side too,
      // where no cookies are set — pass undefined and keep the configured domain.
      cookieOptions: getSharedCookieOptions(
        typeof window === 'undefined' ? undefined : window.location.hostname
      ),
    }
  )
}
